import { Component, OnInit,Input,ViewChild,HostListener, ElementRef } from '@angular/core';
import {BlogService} from "../../service/blog.service";
import {ForumsService} from "../../service/forums.service";
import {commonService} from "../../service/common.service";
import {Globals } from '../../globals';
import { FormBuilder,FormGroup,FormControl,Validators } from '@angular/forms';
import { HttpDownloadProgressEvent, HttpErrorResponse } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalRef,NgbTimeStruct,NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import {ParamMap, Router, ActivatedRoute,Params } from '@angular/router';

@Component({
  selector: 'app-adminblog',
  templateUrl: './adminblog.component.html',
  styleUrls: ['./adminblog.component.css'],
  providers:[BlogService,ForumsService]
})
export class AdminblogComponent implements OnInit {
  msg="";
  bloglist:any;
  newBlog=false;
  blogId=0;
  commentbox=[];
  userData:any;
  commentEditbox=[];
  currentUploadComment:any={};
  currentCommentMediaIds:any=[];
  replybox:any;
  title:any;
  
  blogOption:any;
  msgpopup="";
  blogFields={};
  ckeConfig={}
  modalReference:NgbModalRef;
  msgclass="danger";
  blogsavemessage=false;
  isblogLoad=false;
  isRemaningBlog=true;
  searchFilter:any;
  option={}
  userSearchkey="";
  userList=[];
  selectUser=[];
  currentblog={};
  blogEditFields={};
  editIndex:any;
  constructor(private forumsService:ForumsService,private modalService: NgbModal,private commonService:commonService,private blogService:BlogService,private global: Globals,private router: Router,private route: ActivatedRoute) {
    this.bloglist=[];
    this.searchFilter={};
    this.ckeConfig = {
      height: 300,
      width:'100%',
      language: "en",
      
   //   extraPlugins: 'mathjax',
      
      mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=TeX-AMS_HTML',
     // allowedContent: true,
     // extraPlugins: "divarea",
      toolbar: [
         // { name: "editing", items: ["Scayt", "Find", "Replace", "SelectAll"] },
         // { name: "clipboard", items: ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord", "-", "Undo", "Redo"] },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
        //  { name: "tools", items: ["Maximize", "ShowBlocks", "Preview", "Print", "Templates"] },
         // { name: "document", items: ["Source"] },
          { name: "insert", items: ["Image", "Table", "HorizontalRule", "SpecialChar", "Iframe", "imageExplorer"] },
         //{ name: "insert", items: ["Image", "Table",  "imageExplorer","Iframe"] },
        // For New Line  "/",
          { name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript", "-", "RemoveFormat"] },
          { name: "paragraph", items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent", "Blockquote"] },
         // { name: "justify", items: ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },
        //  { name: "styles", items: ["Styles", "Format", "FontSize", "-", "TextColor", "BGColor"] }
      ],
      filebrowserUploadUrl : this.global.objectStorage+'ckeditor/upload'
  };


    

    this.commonService.profile.subscribe((data:any)=>{
      // console.log('after Load call sub');
       if(data){
       this.userData=data; 
       }else{
         this.userData={};
       } 
 
     });

    
     this.replybox={};
     console.log('min data');
     console.log(this.minDate);

   }

   

 searchUser(){
  let obj={};
  obj['search']=this.userSearchkey;
  this.forumsService.searchUserList(obj).subscribe((data:any)=>{
    if(data.error==0){
      this.userList=data.result;
    }
   
  },(error:HttpErrorResponse)=>{
       // this.msg="internal server error!";
      })

 }

 selectuser(userinfo,event){
  if(event.target.checked) {
    this.selectUser.push(userinfo.id);
  } else {

    var index =  this.selectUser.indexOf(userinfo.id);
    this.selectUser.splice(index,1);   
  } 

 }

 isuserChecked(id){
  let index = this.selectUser.indexOf(id);
 return (index < 0)?false:true;


 }
 filterblog(){
  let obj={};
  obj['newBlog']=true;
  obj['limit']=10;
  obj['offset']=0;
  this.isRemaningBlog=true;
  this.getBlogList(obj);
 }

  ngOnInit() {
     if(this.option){
      this.blogOption=this.option;
      }
      if( this.blogOption && this.blogOption['blogId'] > 0){
        this.blogId=this.blogOption['blogId'];

      }

    let filter={};
    filter['userId']=(this.userData.id)?this.userData.id:0;
    if(this.option['blogId'] > 0){
      filter['blogId']=this.option['blogId'];
      filter['limit']=1;
      filter['offset']=0;

      filter['newBlog']=true;
    }
    this.getBlogList(filter);
  }


  saveblog(blogForm:NgForm){

    this.msgpopup="";
    let localmodalReference=this.modalReference;
    let forumsObj=blogForm.value; 
    //forumsObj.postTitle[forumsObj.postTitle.length -1];
    
    if(this.userData.isBlocked == 1){
      this.msgclass="danger";
      this.msgpopup="You have no permission to post question, Please contact to MadeEasy";
      return false;
    }

    if(blogForm.valid==true){
     
      let blogObj=blogForm.value;
    
      console.log(blogObj);
      let obj={};
      obj['userId']=this.userData.id;
      obj['title']=blogObj.title;
      
      obj['content']=blogObj.content;
      obj['status']=1;
      obj['approve']=1;
      obj['title']=blogObj.title;
      if(blogObj.isfuture==true && Object.keys(blogObj.launchDate).length > 0 && Object.keys(blogObj.launchtime)){
       obj['launchDate']= this.datetimeMerge(blogObj.launchDate,blogObj.launchtime);
     } 
     
      this.blogService.saveBlog(obj).subscribe((data:any)=>{
       
        //this.blogFields['content']="";
        if(data.error==0){
        let newBlog=data.result;
        newBlog['blogLikeCount']=0;
        newBlog['commentCount']=0;
        newBlog['blogunLikeCount']=0;
        newBlog['user']={}
        newBlog['user']=this.userData;   
        this.bloglist.unshift(newBlog);     
       
        this.blogFields={};      
        this.msgclass="success";
        this.msgpopup="Blog has been saved successfully";
        this.blogsavemessage=true;
        this.blogsavemessage=false;
        blogForm.resetForm();

        }
      },(error:HttpErrorResponse)=>{
        this.msgclass="danger";
        this.msgpopup="internal server error!";
      })
    }else{
      this.msgclass="danger";
      this.msgpopup="Please fill all required fields!";
      }

  }

  open(content) {
    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();
      return false;
    } 
    this.blogsavemessage=false;
    this.msgpopup="";
    this.modalReference =  this.modalService.open(content,{ size: 'lg' });          
  }
  getBlogList(obj){
   // obj['status']=1;
    //obj['approve']=1;
    if(obj['offset'] == null){
      obj['offset']=this.bloglist.length;
    }
  
    if(this.searchFilter['title']){
      obj['title']=this.searchFilter['title'];
    }  
    if(this.selectUser.length > 0){
        obj['userIds']=this.selectUser;

    }
   // console.log(obj);
      this.blogService.getBlogList(obj).subscribe((data:any)=>{
          if(data.error==0){
          
            if(data.result.length > 0){
              for(let i=0; i < data.result.length; i++){
                this.customContent(data.result[i]);
              }
            }
          
            if(obj.newBlog==true){
              this.bloglist=data.result;
            
            }else{
             Array.prototype.push.apply(this.bloglist,data.result); 
            }

            if(data.result.length < obj.limit){
              this.isRemaningBlog=false;
            }else{
              this.isRemaningBlog=true;

            }

          }

      },(error:HttpErrorResponse)=>{
        this.msg="internal server error!";
      })


  } 

  loadmoreBlog(){
    this.getBlogList({limit:10,newBlog:false});
  }

  blogdetailredirect(id){
let url =encodeURI(btoa(id));
this.router.navigate(['blog/'+url]) ;
  }

  blogdetailContent(blog){
    blog.isfullcontent=true;

  }

  deleteblog(blogObj,index){
    var r=confirm("Do you want to delete ?");
    if(r==true){
      let obj={};
      obj['id']=blogObj.id;
  this.blogService.deleteBlog(obj).subscribe((data:any)=>{  
    this.bloglist.splice(index,1);
  },(error:HttpErrorResponse)=>{
    this.msg="internal server error!";

  })
     

    }
  }
  editblogBox(blogObj,index,editcontent){
    //console.log(postObj);
    this.currentblog=blogObj;
    this.editIndex=index;
    this.blogEditFields['id']=blogObj.id;
    this.blogEditFields['title']=blogObj.title;
    this.blogEditFields['content']=blogObj.content;     
    this.blogEditFields['isfuture']=false;
    this.blogEditFields['launchDate']=blogObj.launchDate;
    this.blogEditFields['launchtime']={}
    
    console.log(this.blogEditFields);
    this.open(editcontent);
    blogObj.showOption=false;         

  }

  updateblog(blog){
    let content=this.blogEditFields['content'];
    let title=this.blogEditFields['title'];
  let obj={};
  obj['id']=this.currentblog['id'];
  obj['content']=content;
  obj['title']=title;
  console.log(blog);
  console.log(this.blogEditFields);
  if(this.blogEditFields['isfuture']==true && Object.keys(this.blogEditFields['launchDate']).length > 0 && Object.keys(this.blogEditFields['launchtime'])){
    obj['launchDate']= this.datetimeMerge(this.blogEditFields['launchDate'],this.blogEditFields['launchtime']);
  } 

    this.blogService.updateBlog(obj).subscribe((data:any)=>{
      if(data.error==0){
        this.bloglist[this.editIndex]['content']=content;
        this.bloglist[this.editIndex]['title']=title;
     
        //this.customContent(blog);
        this.bloglist[this.editIndex]['editmode']=false;      
        this.modalReference.close();
        this.blogEditFields={}
      }         

    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
    })

}
approve(blog){
  let obj={};
  obj['id']=blog.id;
    this.blogService.approveBlog(obj).subscribe((data:any)=>{
      if(data.error==0){
        blog.approve=data.result;
      }            
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
    })

}
  blogLike(blogObj,react){ 
    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();
      return false;
    }      
    var obj={};
    obj['userId']=this.userData.id;
    obj['blogId']=blogObj.id;
    obj['react']=react;            
        this.blogService.saveBlogLike(obj).subscribe((data:any)=>{
          if(!blogObj.blogLikeCount){
            blogObj.blogLikeCount=0;
          }
          if(!blogObj.blogunLikeCount){
            blogObj.blogunLikeCount=0;
          }
          if(react==0){                
            if(blogObj.mylikeAction=='Like'){
              blogObj.mylike=0;
              blogObj.blogLikeCount -=1;
              blogObj.blogunLikeCount +=1;
            }else if(!blogObj.mylikeAction){
              blogObj.blogunLikeCount +=1;
            }
            blogObj.mylikeAction='Unlike';

          }else{
            if(blogObj.mylikeAction=='Unlike'){
              blogObj.mylike=1;
              blogObj.blogLikeCount +=1;
              blogObj.blogunLikeCount -=1;
            }else if(!blogObj.mylikeAction){
              blogObj.blogLikeCount +=1;
            }
            blogObj.mylikeAction='Like';
          }
                       
        },(error : HttpErrorResponse)=>{              
            this.msg="internal server error!";
        })   
    

  }


  customContent(ans){
    //console.log('ans');
   // console.log(ans);
    let string="";
    ans.shortAns="";
    ans.shortImage="";
   let html =ans.content
   //console.log(this.postId);

    if(this.blogId  > 0 ||  ans.isfullcontent==true){
     string=html;
    }else{
     let chacterlength=0;
     let obj= html.split('<p>');
     var incre=0;
       for(var i in obj){
         incre++;  
         if(obj[i]){

           var StrippedString = obj[i].replace(/(<([^>]+)>)/ig,"");
           chacterlength +=StrippedString.length;
          // console.log(StrippedString);
           //string +='<p>'+obj[i];
           string +=StrippedString;
           //break;
         }
         if(chacterlength > 350){
          ans.isfullcontent=false;
           break;
         }                
       }  
       ans.shortAns=string;
//console.log(incre +'----'+obj.length);
       if(incre < (obj.length-1) ){
        // console.log(html);
         if(html.indexOf('<img') !==false){
         var m,
         urls = [], 
         str = html,
         rex = /<img[^>]+src="?([^"\s]+)"?\s*\/>/g;
         while ( m = rex.exec( str ) ) {
             urls.push( m[1] );
         }

        // console.log( urls );
           if(urls.length > 0){
             ans.shortImage=urls[0];
             //string ='<div class="row grid-divider"><div class="col-sm-8 short-content-ans">'+string+'</div>'+'<div class="col-sm-4 short-image-ans"><img class="img-thumbnail" src="'+urls[0]+'" /></div></div>'; 
           }
         }
       //  let imageobj= html.split('<img');
         //console.log(imageobj);
        // ans.isfullcontent=false;
       }else{
         ans.shortAns=string;
         ans.isfullcontent=true;
       }

    }
    //string=string+'<a class="more-content">more</a>';

   //return string;
  }

  getImagePath(path,anonymously){
    if(!path || anonymously==1){
      path='avatar.png';
    }
  let res=this.global.profileUrl+path;
  return res;

  }
  needLogin(){
    this.commonService.setLoginBox(true);        
  }
  datediff(date){
    let date_future:any;
    let date_now:any;

     date_future = new Date();
     date_now = new Date(date);
     let seconds = Math.floor((date_future - (date_now))/1000);
     let minutes = Math.floor(seconds/60);
     let hours = Math.floor(minutes/60);
     let days = Math.floor(hours/24);
     
       hours = hours-(days*24);
       minutes = minutes-(days*24*60)-(hours*60);
       seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
       let res="";
       if(days>30){
         res=date;
       }else if(days){
         res=days+"d ago";
       }else if(hours){

         res=hours+"h ";
         if(minutes){
           res +=minutes+"m ";
         }            
         res +="ago";
       }else if(minutes){
         res =minutes+"m ago";

       }else{
         res ="now";
       }
       return res;

   }

   commentDetailBox(blog){
     //console.log(blog);
      if(!blog.commentDetailBox || blog.commentDetailBox==false){
        blog.commentDetailBox=true;
      }else{
        blog.commentDetailBox=false;
      }

      this.showAnscomment(blog);

   }
  /**********Comment **********/
  showCommentBox(blogObj){
    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();
      return false;
    } 
    blogObj.showAttachment=false;
    if(blogObj.showCommentBox){
      blogObj.showCommentBox=false;
    }else{
      blogObj.showCommentBox=true;
      
      if(blogObj.commentCount > blogObj.commentCount && blogObj.commentCount < 5){
        blogObj.isCommentLoad=true;
        var obj={};
        obj['userId']=this.userData.id;
        obj['ansId']=blogObj.id;
        obj['limit']=5;
        obj['offset']=blogObj.commentList.length;
      
        this.blogService.getComments(obj).subscribe((data:any)=>{
         
          if(data.error==0){
            if(data.result){
              for(let i in data.result){  
                this.commentEditbox[data.result[i].id]=data.result[i].comment;
              }
            }
            
            Array.prototype.push.apply(blogObj.commentList,data.result); 
            //postObj.postComments.concat(data.result);
           // console.log(postObj.postComments);
          }
          blogObj.isCommentLoad=false;



        },(error : HttpErrorResponse)=>{ 
          blogObj.isCommentLoad=false;     
          this.msg="internal server error!";
        })


      }
    }
  }


  savereply(commentobj,commentValue){
        
    let objthis=this;
    if(commentValue){
          let commentInsertObj={}
          commentInsertObj['comment']=commentValue;
          commentInsertObj['blogId']=commentobj.postId;
          commentInsertObj['userId']=this.userData.id;
          commentInsertObj['pcomment']=commentobj.id;
          commentInsertObj['mediaids']=[];
          if(this.currentCommentMediaIds){
            for(let i in this.currentCommentMediaIds){
              commentInsertObj['mediaids'].push(this.currentCommentMediaIds[i].id);

            }
          }   

          this.blogService.saveComment(commentInsertObj).subscribe((data:any)=>{
            
            if(data.error==0){
              let commentData=data.result;
             
              commentData.user={firstName:this.userData.firstName,lastName:this.userData.lastName,photo:this.userData.photo};
              commentData.likeCount=0;
              if(!commentobj.commentList){
                commentobj.commentList=[];
              }
              commentData.commentAttachments=this.currentCommentMediaIds;
             
             // if(commentobj.commentList.length<5){
                commentobj.commentList.unshift(commentData);
             // }
              commentobj.commentCount +=1;
              objthis.replybox[commentobj.id]="";
              commentobj.commentMedia=[];
            }
            this.currentCommentMediaIds=[];


          },(error : HttpErrorResponse)=>{  
            
              this.msg="internal server error!";
          })

    }       

  }

  saveComment(blogObj,commentValue){

    let objthis=this;
    if(commentValue){
          let commentObj={}
          commentObj['comment']=commentValue;
          commentObj['blogId']=blogObj.id;
          commentObj['userId']=this.userData.id;
          commentObj['mediaids']=[];
          if(this.currentCommentMediaIds){
            for(let i in this.currentCommentMediaIds){
              commentObj['mediaids'].push(this.currentCommentMediaIds[i].id);

            }
          }     
          
         
          this.blogService.saveComment(commentObj).subscribe((data:any)=>{
            
            if(data.error==0){
              let commentData=data.result;                 
              commentData.user={firstName:this.userData.firstName,lastName:this.userData.lastName,photo:this.userData.photo};
              commentData.likeCount=0;
              
              commentData.commentAttachments=this.currentCommentMediaIds;
              if(!blogObj.commentList){
                blogObj.commentList=[];
              }
              
              blogObj.commentList.unshift(commentData);
               
            
              blogObj.commentCount +=1;
           

              blogObj.commentMedia=[];
              this.commentbox[blogObj.id]="";
              blogObj.showAnscomment=false;
              this.showAnscomment(blogObj);
            }
            this.currentCommentMediaIds=[];


          },(error : HttpErrorResponse)=>{  
              
              this.msg="internal server error!";
          })

    }        
  
  }

  loadComment(postObj,forcall,divobject){
    if(!postObj.commentList){
      postObj.commentList=[];

    }
    if(postObj.commentCount > postObj.commentList.length ){
      postObj.isCommentLoad=true;

      console.log(forcall);
    var obj={};
     if(this.userData)
     obj['userId']=this.userData.id;
    
     obj['limit']=5;
     obj['offset']=postObj.commentList.length;
     if(forcall=='Comment'){
      obj['postId']=postObj.id;
     }else if(forcall=='reply'){
      obj['postId']=postObj.postId;
      obj['pcomment']=postObj.id;
     }

     obj['ordertype']='DESC';
     obj['orderby']='id';

     console.log(obj);
     console.log(postObj);

    
      this.blogService.getComments(obj).subscribe((data:any)=>{
       
        if(data.error==0){
          if(data.result){
            for(let i in data.result){

              this.commentEditbox[data.result[i].id]=data.result[i].comment;
            }
          }
         
          Array.prototype.push.apply(postObj.commentList,data.result); 
          
       
        }
        postObj.isCommentLoad=false;



      },(error : HttpErrorResponse)=>{ 
        postObj.isCommentLoad=false;     
        this.msg="internal server error!";
      })


    }
  }
  commentLike(commentData){
    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();  
      return;
    }
    var obj={};
    obj['userId']=this.userData.id;
    obj['commentId']=commentData.id;
    obj['react']=1;  

      if(commentData.mylike){            
        this.blogService.deleteCommentLike(obj).subscribe((data:any)=>{
          if(data.error==0){
          commentData.mylike=0;
          commentData.likeCount -=1;
          }
        },(error : HttpErrorResponse)=>{              
            this.msg="internal server error!";
        })              

      }else{            

        this.blogService.saveCommentLike(obj).subscribe((data:any)=>{
          if(data.error==0){
          commentData.mylike=1;
          commentData.likeCount +=1;
          }
        },(error : HttpErrorResponse)=>{              
            this.msg="internal server error!";
        })            
      }

  }

  showAnscomment(blogObj){

    if(blogObj.showAnscomment==true){
      blogObj.showAnscomment=false;          
      return false;
    }   

   if(!blogObj.commentList || blogObj.commentList.length==0){
     this.loadComment(blogObj,'Comment','');   
   }
   blogObj.showAnscomment=true;  
  

  }


  replyTextboxShow(commentdata){
        
    if(commentdata.isShow){
      commentdata.isShow=false;

    }else{

      commentdata.isShow=true;
      
      if(!commentdata.commentList){
         commentdata.commentList=[];
      }
      if(commentdata.commentCount > commentdata.commentList.length && commentdata.commentList.length < 5){
       
        commentdata.isCommentLoad=true;
      var obj={};
       obj['userId']=this.userData.id;
       obj['blogId']=commentdata.postId;
       obj['pcomment']=commentdata.id;
       obj['limit']=5;
       obj['offset']=commentdata.commentList.length;
       obj['ordertype']='DESC';
       obj['orderby']='id';
      console.log(obj);
        this.blogService.getComments(obj).subscribe((data:any)=>{
         
          if(data.error==0){
            if(data.result){
              for(let i in data.result){

                this.commentEditbox[data.result[i].id]=data.result[i].comment;
              }
            }
            Array.prototype.push.apply(commentdata.commentList,data.result); 
            //postObj.postComments.concat(data.result);
            console.log(commentdata.commentList);
          }
          commentdata.isCommentLoad=false;



        },(error : HttpErrorResponse)=>{ 
          commentdata.isCommentLoad=false;     
          this.msg="internal server error!";
        })
      }
    }

  }
  toggleoption(blogObj){      
   
    if(blogObj.showOption){
      blogObj.showOption=false;
    }else{
      blogObj.showOption=true;
    }
  }

  enableEditor(Obj){
    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();
      return false;
    } 
    Obj.isEditor=true;

  }

  /*********code for time********/
  
datetimeMerge(date,time){
  let string="";
  let month = (date.month<10)?'0'+date.month:date.month ;
  let day = (date.day<10)?'0'+date.day:date.day ;
  
  let hour=(time.hour<10)?'0'+time.hour:time.hour ;
  let minute=(time.minute<10)?'0'+time.minute:time.minute ;

  string=date.year+'-'+month+'-'+day+' '+hour+':'+minute+':00';
  
  return string;

}
time = {hour: 13, minute: 30};
meridian = true;

toggleMeridian() {

  this.meridian = !this.meridian;
}

// This is for the seconds
seconds = true;

toggleSeconds() {
this.seconds = !this.seconds;
}

// This is for the spinners
spinners = true;

toggleSpinners() {
  this.spinners = !this.spinners;
}

// This is for the column step
time2: NgbTimeStruct = {hour: 13, minute: 30, second: 0};
currentDate=new Date();
minDate : NgbDateStruct = {year: this.currentDate.getFullYear(), month: this.currentDate.getMonth()+1, day: this.currentDate.getDate()};
hourStep = 1;
minuteStep = 15;
secondStep = 30;



// This is for the validation
time3;
ctrl = new FormControl('', (control: FormControl) => {
const value = control.value;

if (!value) {
  return null;
}

if (value.hour < 12) {
  return {tooEarly: true};
}
if (value.hour > 13) {
  return {tooLate: true};
}

return null;
});

/*********code for time********/
}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/adminblog/adminblog.component.ts